export enum Roles {
    Admin = 'admin',
    Developer = 'developer',
    Owner = 'owner',
}